import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/calc/error.tsx");
